const {groupByEdition} = require('./editions.cjs')

function groupPlanningStandards(items = []) {
  return groupByEdition(items.map((item, index) => ({item, index, standard_set:item.standard_set})))
    .map(group => ({...group, items:group.items.map(({item,index}) => ({item,index}))}))
}

function updatePlanStandards(plan, standards) {
  return {...plan, content:{...(plan.content || {}), standards}}
}

module.exports = {groupPlanningStandards, updatePlanStandards}
